import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseurl } from "../../../Baseurl";
import AdminSidebar from "../../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../../component/AdminComp/AdminTopbar";
import Swal from "sweetalert2";
import ServiceCategoryNavbar from "./ServiceCategoryNavbar";

import Select, { components } from "react-select";

// Custom checkbox option component
const CustomOption = (props) => {
  return (
    <components.Option {...props}>
      <input
        type="checkbox"
        checked={props.isSelected}
        onChange={() => null}
        style={{ marginRight: 8 }}
      />
      {props.label}
    </components.Option>
  );
};

const indianStates = [
  { label: "All India", value: "All India" },
  { label: "Andhra Pradesh", value: "Andhra Pradesh" },
  { label: "Arunachal Pradesh", value: "Arunachal Pradesh" },
  { label: "Assam", value: "Assam" },
  { label: "Bihar", value: "Bihar" },
  { label: "Chhattisgarh", value: "Chhattisgarh" },
  { label: "Goa", value: "Goa" },
  { label: "Gujarat", value: "Gujarat" },
  { label: "Haryana", value: "Haryana" },
  { label: "Himachal Pradesh", value: "Himachal Pradesh" },
  { label: "Jharkhand", value: "Jharkhand" },
  { label: "Karnataka", value: "Karnataka" },
  { label: "Kerala", value: "Kerala" },
  { label: "Madhya Pradesh", value: "Madhya Pradesh" },
  { label: "Maharashtra", value: "Maharashtra" },
  { label: "Manipur", value: "Manipur" },
  { label: "Meghalaya", value: "Meghalaya" },
  { label: "Mizoram", value: "Mizoram" },
  { label: "Nagaland", value: "Nagaland" },
  { label: "Odisha", value: "Odisha" },
  { label: "Punjab", value: "Punjab" },
  { label: "Rajasthan", value: "Rajasthan" },
  { label: "Sikkim", value: "Sikkim" },
  { label: "Tamil Nadu", value: "Tamil Nadu" },
  { label: "Telangana", value: "Telangana" },
  { label: "Tripura", value: "Tripura" },
  { label: "Uttar Pradesh", value: "Uttar Pradesh" },
  { label: "Uttarakhand", value: "Uttarakhand" },
  { label: "West Bengal", value: "West Bengal" },
  { label: "Andaman and Nicobar Islands", value: "Andaman and Nicobar Islands" },
  { label: "Chandigarh", value: "Chandigarh" },
  { label: "Dadra and Nagar Haveli and Daman and Diu", value: "Dadra and Nagar Haveli and Daman and Diu" },
  { label: "Delhi", value: "Delhi" },
  { label: "Jammu and Kashmir", value: "Jammu and Kashmir" },
  { label: "Ladakh", value: "Ladakh" },
  { label: "Lakshadweep", value: "Lakshadweep" },
  { label: "Puducherry", value: "Puducherry" }, 
];


const ServiceStateCity = () => {
  const [categories, setCategories] = useState([]);
  const [whatWeDoId, setWhatWeDoId] = useState("");
  const [categoryId, setCategoryId] = useState("");
  const [subcategoryId, setSubcategoryId] = useState("");
  const [stateInput, setStateInput] = useState("");
  const [states, setStates] = useState([]);
const [subSubcategoryId, setSubSubcategoryId] = useState("");


  useEffect(() => {
    axios.get(`${baseurl}getAllServiceCategories`)
      .then((res) => {
        setCategories(res.data.data || []);
      })
      .catch((err) => {
        console.error("Fetch categories error:", err);
      });
  }, []);

  const generateSlug = (text) => {
    return text.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9\-]/g, "");
  };

  const handleAddState = () => {
    const trimmedState = stateInput.trim();
    if (!trimmedState) return;
    if (states.includes(trimmedState)) {
      Swal.fire("Duplicate", "State already added", "warning");
      return;
    }
    setStates([...states, trimmedState]);
    setStateInput("");
  };

  const handleRemoveState = (index) => {
    const newStates = [...states];
    newStates.splice(index, 1);
    setStates(newStates);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (states.length === 0) {
      Swal.fire("Error", "Please add at least one state", "error");
      return;
    }

    try {
      for (const st of states) {
        const payload = {
          service_title: st,
          has_service: false,
          slug: generateSlug(st),
          parent_id: subSubcategoryId || null
        };
        await axios.post(`${baseurl}addServiceCategory`, payload);
      }
      Swal.fire("Success", "States added successfully!", "success").then(() => window.location.reload());
    } catch (err) {
      console.error("Submit error:", err);
      Swal.fire("Error", "Failed to add one or more states", "error");
    }
  };

  // Category filters
  const whatWeDoList = categories.filter(cat => cat.parent_id === null);
  const categoryList = categories.filter(cat => cat.parent_id === parseInt(whatWeDoId));
  const subcategoryList = categories.filter(cat => cat.parent_id === parseInt(categoryId));
const subSubcategoryList = categories.filter(cat => cat.parent_id === parseInt(subcategoryId));


  return (
    <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />
      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar />
        <div className="container-fluid text-start">
          <ServiceCategoryNavbar />

          <div className="crd1">
            <h4 className="mb-3">Add States under Subcategory</h4>
            <div className="row">
              <div className="col-md-6">
                <form onSubmit={handleSubmit} className="row g-3 text-start">

                  {/* What We Do Dropdown */}
                  <div className="col-md-12">
                    <label>What We Do</label>
                    <select
                      className="form-select"
                      required
                      value={whatWeDoId}
                      onChange={(e) => {
                        setWhatWeDoId(e.target.value);
                        setCategoryId("");
                        setSubcategoryId("");
                      }}
                    >
                      <option value="">-- Select --</option>
                      {whatWeDoList.map((cat) => (
                        <option key={cat.id} value={cat.id}>
                          {cat.service_title}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Category Dropdown */}
                  <div className="col-md-12">
                    <label>Category</label>
                    <select
                      className="form-select"
                      required
                      value={categoryId}
                      onChange={(e) => {
                        setCategoryId(e.target.value);
                        setSubcategoryId("");
                      }}
                      disabled={!whatWeDoId}
                    >
                      <option value="">-- Select --</option>
                      {categoryList.map((cat) => (
                        <option key={cat.id} value={cat.id}>
                          {cat.service_title}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Subcategory Dropdown */}
                  <div className="col-md-12">
                    <label>Subcategory</label>
                    <select
                      className="form-select"
                      required
                      value={subcategoryId}
                      onChange={(e) => setSubcategoryId(e.target.value)}
                      disabled={!categoryId}
                    >
                      <option value="">-- Select --</option>
                      {subcategoryList.map((cat) => (
                        <option key={cat.id} value={cat.id}>
                          {cat.service_title}
                        </option>
                      ))}
                    </select>
                  </div>


                  <div className="col-md-12">
  <label>Sub-Subcategory</label>
  <select
    className="form-select"
    required
    value={subSubcategoryId}
    onChange={(e) => setSubSubcategoryId(e.target.value)}
    disabled={!subcategoryId}
  >
    <option value="">-- Select --</option>
    {subSubcategoryList.map((cat) => (
      <option key={cat.id} value={cat.id}>
        {cat.service_title}
      </option>
    ))}
  </select>
</div>




                  {/* State Input & Add Button */}
                  {/* State Dropdown & Add Button */}
<div className="col-md-12">
  <label>State</label>
  <Select
    options={indianStates}
    isMulti
    placeholder="Select state(s)"
    isDisabled={!subcategoryId}
    closeMenuOnSelect={false}
    hideSelectedOptions={false}
    components={{ Option: CustomOption }}
    value={indianStates.filter((opt) => states.includes(opt.value))}
    onChange={(selectedOptions) => {
      const selectedValues = selectedOptions.map((opt) => opt.value);
      setStates(selectedValues);
    }}
  />
</div>

{/* State List */}
{states.length > 0 && (
  <div className="col-md-12 mt-3">
    <label>States to be added:</label>
    <ul className="list-group">
      {states.map((st, idx) => (
        <li
          className="list-group-item d-flex justify-content-between align-items-center"
          key={idx}
        >
          {st}
          <button
            type="button"
            className="btn btn-sm btn-danger"
            onClick={() => {
              const newStates = [...states];
              newStates.splice(idx, 1);
              setStates(newStates);
            }}
          >
            Remove
          </button>
        </li>
      ))}
    </ul>
  </div>
)}




                  <div className="col-12 text-end">
                    <button type="submit" className="btn btn-primary">Add States</button>
                  </div>

                </form>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default ServiceStateCity;
